import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import UserContext, { useIsLoggedIn } from '~/context/common/UserContext';
import AcquisitionContext from '~/context/home/AcquisitionContext';
import NextBestActionContext from '~/context/home/NextBestActionContext';
import { fetchFeed } from '~/services/home';

export default function useGetNextBestAction() {
  const { isFinanceRestricted } = useContext(AcquisitionContext);
  const {
    actions: { setData, setLoading }
  } = useContext(NextBestActionContext);
  const {
    userState: { isLoaded }
  } = useContext(UserContext);
  const isLoggedIn = useIsLoggedIn();

  useEffectWithController(
    controller => {
      if (!isLoaded) return;

      setLoading();

      fetchFeed(
        {
          isFinanceRestricted,
          useAuth: isLoggedIn
        },
        controller
      ).then(setData);
    },
    [isFinanceRestricted, isLoaded, isLoggedIn, setData, setLoading]
  );
}
